import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum WorkspaceStepValues {
  workspaceTour = "WORKSPACE_TOUR",
  chatDatapiece = "CHAT_DATAPIECE",
  trackingAnAction = "TRACKING_ACTION",
  settingAlert = "SETTING_ALERT",
  addNewUser = "ADD_NEW_USER",
  addNewGroup = "ADD_NEW_GROUP",
}

export interface TutorialsState {
  currentWorkspaceStepValue: WorkspaceStepValues;
  workspaceTourRunState: boolean;
  selectOneDataPiece: boolean;
  toggleMenuFunc: any;
  isChartsOnDashboard: boolean;
}

const INITIAL_STATE = {
  currentWorkspaceStepValue: null,
  workspaceTourRunState: false,
  selectOneDataPiece: false,
  toggleMenuFunc: null,
  isChartsOnDashboard: false,
};

export type TutorialsPayload = {
  stepValue: string;
  start: boolean;
};

const TutorialsSlice = createSlice({
  name: "tutorials",
  initialState: INITIAL_STATE,
  reducers: {
    setTutorialsStepValue: (state, action: PayloadAction<TutorialsPayload>) => {
      if (action.payload.stepValue) {
        state.currentWorkspaceStepValue = action.payload.stepValue;
        state.workspaceTourRunState = action.payload.start;
      } else {
        state.currentWorkspaceStepValue = null;
        state.workspaceTourRunState = false;
      }
    },
    setToggleMenu: (state, action: PayloadAction<any>) => {
      state.toggleMenuFunc = action.payload;
    },
    endWorkspaceTour: (state) => {
      state.currentWorkspaceStepValue = null;
      state.workspaceTourRunState = false;
    },
    stopWorkspaceTour: (state, action: PayloadAction<TutorialsPayload>) => {
      // state.currentWorkspaceStepValue = null;
      state.workspaceTourRunState = false;
    },
    startWorkspaceTour: (state) => {
      state.workspaceTourRunState = true;
    },
    setSelectOneDataPiece: (state, action: PayloadAction<boolean>) => {
      state.selectOneDataPiece = action.payload;
    },
    setChartsOnDashboard: (state, action: PayloadAction<boolean>) => {
      state.isChartsOnDashboard = action.payload;
    },
    resetTutorials: (state) => INITIAL_STATE,
  },
});

export const {
  setTutorialsStepValue,
  stopWorkspaceTour,
  setSelectOneDataPiece,
  startWorkspaceTour,
  setToggleMenu,
  endWorkspaceTour,
  resetTutorials,
  setChartsOnDashboard,
} = TutorialsSlice.actions;

export const TutorialsSliceReducer = TutorialsSlice.reducer;
